
import { isOverseasVersion } from 'common-module/src/util';
// 常量映射
export const IconListMap = {
  'attachment': 'iconwenjianjia',
  'doc': 'iconDoc',
  'issue': isOverseasVersion ? 'iconleiga-logo' : 'iconicon_LigaAI',
  'guide': 'iconshiyongshouce'
};

export const IconMap = {
  pdf: 'iconpdf',
  docx: 'iconword',
  doc: 'iconword',
  md: 'iconMarkdown',
  txt: 'iconTXT'
};
